<template>
    <div class="automation-wizard-field-time">
        <CompassFormItem v-bind="formItemProps">
            <CompassTimePicker
                v-model="localValue"
                v-bind="timePickerProps"
                menuClass="automation-wizard-field-time"
                @update:value="handleInput"
            />
        </CompassFormItem>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: corpMapState } = createNamespacedHelpers('corp');
const { mapState: userMapState } = createNamespacedHelpers('user');

export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },
    },
    emits: ['update:value'],
    data() {
        return {
            localValue: '',
        };
    },
    computed: {
        ...corpMapState(['hourformat']),
        ...userMapState(['timezone']),
        timePickerFormat() {
            return this.hourformat === '12' ? '12' : '24';
        },
        timeFormat() {
            return this.timePickerFormat === '12' ? 'hh:mm A' : 'HH:mm';
        },
        formItemProps() {
            return {
                ...this.field.props?.formItem,
                label: this.field.props?.formItem?.label || '',
                info: this.field.props?.formItem?.info || '',
                required: this.field.required || false,
                requiredLabel:
                    this.field.props?.formItem?.requiredLabel ||
                    this.$t.__('common.labels.required'),
                error: '',
            };
        },
        timePickerProps() {
            return {
                ...this.field.props?.timePicker,
                hourFormat: this.timePickerFormat,
                selectorActionLabel: this.$t.__('common.actions.apply'),
                autoScroll: true,
            };
        },
    },
    created() {
        this.localValue = this.parseValue(this.value);
        this.$emit('update:value', this.convertTimeToHourFormat(this.localValue));
    },
    methods: {
        parseValue(value) {
            const parsed = value?.includes?.('hour') ? this.convertHourFormatToTime(value) : value;
            return parsed || this.getMidnightTime();
        },
        getMidnightTime() {
            return this.timePickerFormat === '12' ? '12:00 AM' : '00:00';
        },
        convertHourFormatToTime(hourValue) {
            const match = hourValue.match(/\+\s*(\d+)\s*hour/);
            if (!match) {
                return '';
            }
            const hours = parseInt(match[1], 10);
            return moment()
                .utc()
                .startOf('day')
                .add(hours, 'hours')
                .tz(this.timezone)
                .format(this.timeFormat);
        },
        convertTimeToHourFormat(timeValue) {
            const actualTimeValue = timeValue || this.getMidnightTime();
            const utcTime = moment(actualTimeValue, this.timeFormat).tz(this.timezone, true).utc();
            const hours = utcTime.hour() + utcTime.minute() / 60;
            return `+${Math.round(hours)}hour`;
        },
        handleInput(timeValue) {
            const hourFormatValue = this.convertTimeToHourFormat(timeValue);
            this.$emit('update:value', hourFormatValue);
        },
    },
};
</script>
